export default __webpack_public_path__ + "static/media/018-blowfish.9247918a.svg";